import Dispatcher from '../dispatcher';
import { WheelAlignmentInfoLightBoxActions } from '../constants/wheel_alignment_info_light_box/wheel_alignment_info_light_box_actions';

function showAction() {
    Dispatcher.handleWheelAlignmentInfoLightboxAction({
        type: WheelAlignmentInfoLightBoxActions.SHOW
    });
}

function hideAction() {
    Dispatcher.handleWheelAlignmentInfoLightboxAction({
        type: WheelAlignmentInfoLightBoxActions.HIDE
    });
}

function expandAction() {
    Dispatcher.handleWheelAlignmentInfoLightboxAction({
        type: WheelAlignmentInfoLightBoxActions.EXPAND
    });
}

export {
    showAction,
    hideAction,
    expandAction
};
